// Size Chart Popup
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.querySelector(".overlay_background");
  const popup = document.querySelector(".size_guide_mainpopup_new");
  if (!overlay || !popup) return; 
  document.querySelectorAll(".size_guide_new").forEach(btn => {
    btn.addEventListener("click", () => {
      document.body.classList.add("overflow-hidden");
      overlay.classList.add("open");
      popup.style.display = "block";
    });
  });
  document
    .querySelectorAll(".overlay_background, .size_guide_mainclose_new")
    .forEach(el => {
      el.addEventListener("click", () => {
        document.body.classList.remove("overflow-hidden");
        overlay.classList.remove("open");
        popup.style.display = "none";
      });
    });
});
